export default "__VITE_ASSET__CCh8G7Ld__"